// extracted by mini-css-extract-plugin
export default {"detail":"detail_detail__HcfKO","backto":"detail_backto__dCG8Z","backto_link_button":"detail_backto_link_button__DLh4d","contents":"detail_contents__8+iYk"};